export default [
  "files_invoice",
  "files_act",
  "files_account",
  "files_upd",
  "files_other",
];
